import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useIsLoggedIn } from 'modules/Auth/hooks';
import { Row, Col } from 'components/Grid';
import { SSOProviders } from 'modules/Auth/components/Login/SSOProviders';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { useUrlWithParams } from 'modules/Auth/hooks/useUrlWithParams';
import { Link } from 'components/Link';
import { useLoginRouteHandler } from 'modules/Auth/useLoginRouteHandler';
import { Footer } from '../Login/Footer';
import { SignupForm } from './SignupForm';
import { SignupBanner } from '../Banners';
import { authWrapper, authContainer, signupForm, formGridWrapper, annotation, textLink } from '../styles';

export function Signup({ siteKey, defaultCaptchaToken }: { siteKey?: string; defaultCaptchaToken?: string }): JSX.Element | null {
  const router = useRouter();
  const isLoggedIn = useIsLoggedIn();
  const query = router.query as { from?: string; recovery_path?: string };
  const { track } = useDataCollection();
  const { handleLoginRedirection } = useLoginRouteHandler();

  useEffect(() => {
    if (isLoggedIn) {
      handleLoginRedirection();
    }
  }, [isLoggedIn]);

  const loginUrl = useUrlWithParams('/login');

  const onSignUpBtnClick = (btnText: string): void => {
    track('Signup Button Clicked', { pageName: 'sign_up_page', text: btnText });
  };

  const onSignUp = (): void => {
    handleLoginRedirection();
  };

  return (
    <div className={authWrapper}>
      <div className={authContainer}>
        <Row justifyContent="center">
          <Col xs={10} md={10} lg={6}>
            <div className={signupForm}>
              <div className={formGridWrapper}>
                <SignupForm onSignUp={onSignUp} siteKey={siteKey} defaultCaptchaToken={defaultCaptchaToken} />
                <p className={annotation}>
                  Already have an account?&nbsp;
                  <Link className={textLink} href={loginUrl} onClick={() => onSignUpBtnClick('Log in')}>
                    Log in
                  </Link>
                </p>
                <SSOProviders isSignup recoveryPath={query.from} />
              </div>
            </div>
          </Col>
        </Row>

        <div className="footer-auth-area">
          <Footer />
        </div>
      </div>
      <SignupBanner />
    </div>
  );
}
